import React from 'react'
import withView from '../../../cmn/docAutomation/withView';
import FormDialog from '../../../../library/form/components/FormDialog';
import SarasTrans from "../../../../library/notifications/SarasTrans";
import FormInput from '../../../../library/form/components/FormInput';
import FormTitle from "../../../../library/form/components/FormTitle";
import RolePrivilegeAccessScopeEditorRow from "./RolePrivilegeAccessScopeEditorRow";
import RolePrivilegeAdvScopeEditorRow from "./RolePrivilegeAdvScopeEditorRow";
import RolePrivilegeRecordScopeEditorRow from "./RolePrivilegeRecordScopeEditorRow";

const RolePrivilegeEditor = (props) => {
    const { formObject, viewData, ...restProps } = props;

    if(!viewData)
        return(null);

    let rowData = formObject.getFormRow("", "");

    console.log("rowData", rowData);

    const privilegeScopeGroups = Object.values(rowData.rowValues || {})
        .reduce((groups, rowValue) => {
            const scopeId = rowValue?.dataList?.privilegeScopeId;

            if (!scopeId) {
                return groups;
            }

            if (!groups[scopeId]) {
                groups[scopeId] = {
                    scopeId,
                    scopeName: rowValue.dataList.privilegeScopeName,
                    scopeKey: rowValue.dataList.privilegeScopeKey,
                    rows: []
                };
            }

            groups[scopeId].rows.push(rowValue);

            return groups;
        }, {});

    const sortedPrivilegeScopeGroups = Object.values(privilegeScopeGroups)
        .map((group) => ({
            ...group,
            rows: group.rows.sort((a, b) => a.sortKey - b.sortKey)
        }))
        .sort((a, b) => {
            const aMinSortKey = Math.min(...a.rows.map((row) => row.sortKey));
            const bMinSortKey = Math.min(...b.rows.map((row) => row.sortKey));

            return aMinSortKey - bMinSortKey;
        });

    const renderAccessScopeGroup = (group) => {
        return (
            <div key={group.scopeId} className="uiSpacer10">
                <div className="uiLbl uiSpacerBottom5">{group.scopeName}</div>
                <ul style={{"columnCount":2}}>
                    {
                        group.rows.map((row) => (
                            <RolePrivilegeAccessScopeEditorRow formObject={formObject} rowValueKey={row.key} viewData={row} key={row.key} />
                        ))
                    }
                </ul>
            </div>
        )
    }

    const renderRecordScopeGroup = (group) => {
        return (
            <div key={group.scopeId} className="uiSpacer10">
                <div className="uiLbl uiSpacerBottom5">{group.scopeName}</div>
                <ul style={{"columnCount":1}}>
                    {
                        group.rows.map((row) => (
                            <RolePrivilegeRecordScopeEditorRow formObject={formObject} rowValueKey={row.key} viewData={row} key={row.key} />
                        ))
                    }
                </ul>
            </div>
        )
    }

    const renderAdvanceScopeGroup = (group) => {
        return (
            <div key={group.scopeId} className="uiSpacer10">
                <div className="uiLbl uiSpacerBottom5">{group.scopeName}</div>
                <ul style={{"columnCount":2}}>
                    {
                        group.rows.map((row) => (
                            <RolePrivilegeAdvScopeEditorRow formObject={formObject} rowValueKey={row.key} viewData={row} key={row.key} />
                        ))
                    }
                </ul>
            </div>
        )
    }

    const renderScopeGroup = (group) => {
        switch (String(group.scopeId)) {
            case "1":
                return renderAccessScopeGroup(group);
            case "2":
                return renderRecordScopeGroup(group);
            case "3":
                return renderAdvanceScopeGroup(group);
            default:
                return null;
        }
    }

    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true} formObject={formObject}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" } }} contentStyle={{ height: '370px' }}
            formStyle={{ width: '743px' }} formTitle={<FormTitle formObject={formObject} value="Role Header" />}
        >
            <div>
                <div className="uiRow">
                    <span className="uiLbl"><SarasTrans value="Document Type" /></span>
                    <FormInput roClass="uiHighlightBlue" style={{width: '300px'}} formObject={formObject} rowKey="" className="uiVal"
                        action={{ InputType: "ac", actionId:'refresh', paramName: "docType", acMethod: "DocumentType", actionparam:{change:"1"}  }}
                    />
                </div>
                <ul className="">
                    <li>
                        <div className="uiRow uiSpacer10">
                            {
                                sortedPrivilegeScopeGroups.map((group) => renderScopeGroup(group))
                            }
                        </div>
                    </li>
                </ul>
            </div>
        </FormDialog>
    )
}

export default withView(RolePrivilegeEditor, "rolePrivilege", "rolePrivilege")